<div *ngIf="isVisible" class="floating-upsell">
  <div class="content">
    <img width="46px" [ngStyle]="{transform: 'scale(' + assetTransform + ')', 'margin-top': assetMarginTop}" [src]="assetURL" />
    <span
      class="phx-web-type-title-small text-nowrap phx-web-color-content-on-inverted-emphasis"
      [innerHTML]="header"
    ></span>
    <button
      class="ml-auto mr-24 text-nowrap min-w-fit"
      phx-button
      phxSize="small"
      phxButtonRole="secondary"
      phxBackground="inverted"
      (click)="handleCTAClick(CTAs[0])"
      i18n
    >{{getCTAText(CTAs[0])}}</button>
  </div>
  <button
    (click)="dismiss()"
    phx-icon-button
    [phxIcon]="crossIcon"
    phxIconButtonSize="small"
    phxIconButtonType="on-bold"
  ></button>
</div>

<!-- Modal -->
<app-expansion-upsells-modal
  (onDismiss)="dismissModal()"
  (onClose)="showModal = false"
  [isVisible]="showModal"
  [heading]="modalHeader"
  [body]="modalBody"
  [CTAs]="modalCTAs"
  [industry]="industry"
  [parentUpsell]="upsellType"
  [assetURL]="modalAssetURL"
></app-expansion-upsells-modal>